import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import notFound from '../../../public/assets/notFound.png';

export default function NoDataFound({ onClick, buttonText }) {
  return (
    <div className="bg-white h-screen relative container mx-auto">
      <div className="flex flex-col items-center justify-center w-full h-[90vh] bg-[#f7fbff] px-4 absolute top-10">
        <div className="relative w-64 h-48 mb-6">
          <Image
            src={notFound}
            alt="No Data Found"
            layout="fill"
            objectFit="contain"
            priority
          />
        </div>

        <h2 className="text-lg sm:text-xl font-semibold text-black mb-2">
          No Data Found
        </h2>

        <p className="text-sm sm:text-base text-gray-600 text-center mb-6 max-w-md">
          We’re sorry, no data available at the moment.
          {' '}
          <br />
          Please check back later.
        </p>

        <button
          type="button"
          onClick={onClick}
          className="px-6 py-2 bg-[#0267b1] text-white font-medium text-sm sm:text-base rounded shadow hover:bg-[#025a9b] transition"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

NoDataFound.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
};
